import React from 'react';
import {Page, Text, View, Document, Image} from '@react-pdf/renderer';
import {withTranslation} from "react-i18next";
import {EXT_TITLE, VERSION} from "../../../../config/consts";
import {styles} from "./styles";
import moment from "moment";
import config from "../../../../config/config";
import {ImageRender} from "../Images";
import {SocialIcon} from "../Icons";


const ExportPdfAvatars = ({t, data: exportData}) => {
  return (
    <Document>
      <Page style={styles.body} orientation={'landscape'}>
        <Text style={styles.header} fixed>{t("Created by")} {config.appTitle || EXT_TITLE} {VERSION}</Text>
        <View style={styles.headerPadding} fixed/>


        <View style={{borderBottom: '1px solid #ececec', width: '100%'}}>
          <Text style={{marginBottom: '10px', fontFamily: 'pdfFont', fontSize: '18px'}}>{t("Avatars list")}</Text>
          <View style={{width:'100%'}} >
            {
              exportData.map(({meta, avatars = []}) => {
                //console.log('meta', meta);
                return <View key={meta?.id}>
                  <View style={{display: 'flex', flexFlow: 'row', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', marginBottom: '5px', marginRight: '10px', width: '100%', backgroundColor: '#F0F1F2'}}>
                    <View style={{width: '300px', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                      <View style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center'}}>
                        {
                          meta?.avatar ? ImageRender(meta?.avatar, {width: '30px', height: '30px', objectFit: 'cover', borderRadius: '15px'}) : <View style={{width: '30px', height: '30px', marginRight: '10px'}} />
                        }
                        <Text style={{fontSize: '10px', fontFamily: 'pdfFont', overflow: 'hidden', textOverflow: 'ellipsis'}}>{meta?.name}</Text>
                      </View>
                    </View>
                    <View style={{width: '200px',}}>
                      <View style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', gap: '10px'}}>
                        {avatars.map((ava, idx) => (
                          <SocialIcon
                            key={idx}
                            network={ava?.domain}
                          />
                        ))}
                      </View>
                    </View>
                    <View style={{width: '100px', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                      <Text style={{fontSize: '8px', fontFamily: 'pdfFont'}}>.</Text>
                    </View>
                    <View style={{width: '100px', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                      <Text style={{fontSize: '8px', fontFamily: 'pdfFont', overflow: 'hidden', textOverflow: 'ellipsis'}}>.</Text>
                    </View>
                    <View style={{width: '100px', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                      <Text style={{fontSize: '8px', fontFamily: 'pdfFont', overflow: 'hidden', textOverflow: 'ellipsis'}}>{meta?.username}</Text>
                    </View>
                    <View style={{width: '200px', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                      <Text style={{fontSize: '8px', fontFamily: 'pdfFont', overflow: 'hidden', textOverflow: 'ellipsis'}}>{meta?.email}</Text>
                    </View>
                    <View style={{width: '150px', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                      <Text style={{fontSize: '8px', fontFamily: 'pdfFont', overflow: 'hidden', textOverflow: 'ellipsis'}}>{meta?.phone}</Text>
                    </View>
                    <View style={{width: '200px', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                      <Text style={{fontSize: '10px', fontFamily: 'pdfFont', overflow: 'hidden', textOverflow: 'ellipsis'}}>.</Text>
                    </View>
                  </View>
                  {avatars.map((ava, idx) => (
                    <View key={ava.id} style={{display: 'flex', flexFlow: 'row', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', marginBottom: '5px', marginRight: '10px', width: '100%'}}>
                      <View style={{width: '300px', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                        <View style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center'}}>
                          <View style={{width: '30px', height: '30px', marginRight: '10px'}} />
                          <Text style={{fontSize: '10px', fontFamily: 'pdfFont', overflow: 'hidden', textOverflow: 'ellipsis'}}>{ava?.username}</Text>
                        </View>
                      </View>
                      <View style={{width: '200px',}}>
                        <SocialIcon network={ava?.domain}/>
                      </View>
                      <View style={{width: '100px', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                        <Text style={{fontSize: '8px', fontFamily: 'pdfFont'}}>{ava?.module}</Text>
                      </View>
                      <View style={{width: '100px', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                        <Text style={{fontSize: '8px', fontFamily: 'pdfFont', overflow: 'hidden', textOverflow: 'ellipsis'}}>{ava?.updatedStatus}</Text>
                      </View>
                      <View style={{width: '100px', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                        <Text style={{fontSize: '8px', fontFamily: 'pdfFont', overflow: 'hidden', textOverflow: 'ellipsis'}}>{meta?.username}</Text>
                      </View>
                      <View style={{width: '200px', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                        <Text style={{fontSize: '8px', fontFamily: 'pdfFont', overflow: 'hidden', textOverflow: 'ellipsis'}}>{meta?.email}</Text>
                      </View>
                      <View style={{width: '150px', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                        <Text style={{fontSize: '8px', fontFamily: 'pdfFont', overflow: 'hidden', textOverflow: 'ellipsis'}}>{meta?.phone}</Text>
                      </View>
                      <View style={{width: '200px', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                        <Text style={{fontSize: '10px', fontFamily: 'pdfFont', overflow: 'hidden', textOverflow: 'ellipsis'}}>{ava?.status}</Text>
                      </View>
                    </View>
                  ))}
                  <View style={{width: '100%', paddingBottom: '15px'}} />
                </View>

              })
            }
          </View>
        </View>

        <Text style={styles.pageNumber} render={({pageNumber, totalPages}) => (
          `${pageNumber} / ${totalPages}`
        )} fixed/>
      </Page>
    </Document>
  )
};


export default withTranslation()(ExportPdfAvatars);